/* unplugin-vue-components disabled */import { render } from "./tableCell.vue?vue&type=template&id=155b6451"
const script = {}

import "./tableCell.vue?vue&type=style&index=0&id=155b6451&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__